<template>
  <div class="homepage_wrap">
    <!-- 导航栏 -->
    <routerCom btnIndex="0" :changePop="changePop"/>
    <div class="imgArr">
      <img style="margin-top: -6px;" src="../assets/img/home/titleBg.png" alt="" />
      <img :onClick="openApp" src="../assets/img/home/moreBg.png" alt="" />
      <img :onClick="openApp" src="../assets/img/home/titleBg2.png" alt="" />
      <img src="../assets/img/home/appBg1.png" alt="" />
      <img src="../assets/img/home/appBg2.png" alt="" />
      <img :onclick="changePop" src="../assets/img/home/bomBg.png" alt="" />
      <img style="margin-top: -6px;" src="../assets/img/home/infoBg.png" alt="" />
    </div>
  </div>
</template>

<script>
import routerCom from './routerCom.vue'
export default {
  name: 'mainHome',
  components:{
    routerCom,
  },
  props: {
    isPopShow:Function
  },
  methods: {
		openApp() {
			this.$router.push("/appCenter");
		},
    changePop(isp){
      this.isPopShow(isp);
    }
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

.homepage_wrap {
	width: 1280px;
	margin: auto;
  text-align: center;
}

.imgArr img{
  margin: 32px auto 0 auto;
  max-width: 1280px;
}
</style>
